import { css, styled } from '@thg-commerce/enterprise-theme'
import {
  margin,
  mq,
  spacing,
  Text,
  TextDecoration,
} from '@thg-commerce/gravity-theme'

export const StyledWidgetCountdownContainer = styled.a<{
  textDecoration?: TextDecoration
  backgroundColour?: string
}>`
  text-decoration: ${(props) => props.textDecoration};
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-bottom: ${spacing(4)};
  background: ${(props) =>
    props.backgroundColour ??
    props.theme.widget.dispatchAndDateCountdownWidget?.background ??
    'inherit'};
`

export const WidgetTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  padding: ${spacing(4)} ${spacing(4)} 0 ${spacing(4)};
  ${(props) =>
    margin({
      bottom:
        props.theme.widget.dispatchAndDateCountdownWidget?.margin?.bottom ?? 3,
    })};
`

export const WidgetCountdownTitle = styled.span<{
  titleColour?: string
}>`
  ${Text('large1', 'alternate')};
  color: ${(props) =>
    props.titleColour ??
    props.theme.widget.dispatchAndDateCountdownWidget?.color};
`

export const WidgetCountdownSubTitle = styled.span<{
  subtitleColour?: string
}>`
  ${(props) =>
    Text(
      props.theme.widget.dispatchAndDateCountdownWidget?.title?.font?.entry ||
        'small',
      props.theme.widget.dispatchAndDateCountdownWidget?.title?.font?.style ||
        'default',
    )};

  ${(props) =>
    `color: ${
      props.subtitleColour ??
      props.theme.widget.dispatchAndDateCountdownWidget?.color
    }`};
`

export const DateCountdownStyledContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  ${(props) =>
    props.theme.widget.dispatchAndDateCountdownWidget?.containerStyle
      ?.containerGap &&
    `gap: ${spacing(
      props.theme.widget.dispatchAndDateCountdownWidget?.containerStyle
        ?.containerGap,
    )}`};

  padding: ${(props) =>
    `${spacing(
      props.theme.widget.dispatchAndDateCountdownWidget?.containerStyle?.padding
        .top || 1.25,
    )} ${spacing(
      props.theme.widget.dispatchAndDateCountdownWidget?.containerStyle?.padding
        .bottom || 0,
    )}`};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: ${(props) =>
      `${spacing(
        props.theme.widget.dispatchAndDateCountdownWidget?.containerStyle
          ?.responsivePadding.top || 0,
      )} ${spacing(
        props.theme.widget.dispatchAndDateCountdownWidget?.containerStyle
          ?.responsivePadding.left || 0,
      )} ${spacing(
        props.theme.widget.dispatchAndDateCountdownWidget?.containerStyle
          ?.responsivePadding.bottom || 0,
      )}`};
  }
`

export const Separator = styled.div<{ separatorColour?: string }>`
  ${Text('bodyText', 'alternate')};
  color: ${(props) =>
    props.separatorColour
      ? props.separatorColour
      : props.theme.widget.dispatchAndDateCountdownWidget?.colorSeparator ??
        props.theme.colors.palette.greys.white};
  padding-top: ${(props) =>
    props.theme.widget.dispatchAndDateCountdownWidget?.paddingSeparator?.top ??
    0};
`

export const StyledTimeCountdown = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  ${(props) =>
    props.theme.widget.dispatchAndDateCountdownWidget?.timerSpanStyle &&
    `width: 94px`};
`

export const TimerSpan = styled.span<{
  digitsColour?: string
}>`
  ${Text('medium1', 'alternate')};

  color: ${(props) =>
    props.digitsColour ??
    props.theme.widget.dispatchAndDateCountdownWidget?.color ??
    props.theme.colors.palette.greys.white};

  ${(props) =>
    props.theme.widget.dispatchAndDateCountdownWidget?.timerSpanStyle
      ? css`
          width: 100%;
          display: flex;
          justify-content: center;
          gap: 6px;

          > span {
            height: 100%;
            border: ${(props) =>
              `${props.theme.widget.dispatchAndDateCountdownWidget?.border?.width} ${props.theme.widget.dispatchAndDateCountdownWidget?.border?.style} ${props.theme.widget.dispatchAndDateCountdownWidget?.border?.color}`};
            border-radius: ${(props) =>
              props.theme.widget.dispatchAndDateCountdownWidget?.borderRadius
                ?.radius};
            padding: ${spacing(1.25)} ${spacing(1.5)};
          }
          padding-bottom: ${spacing(1)};
        `
      : css`
          > span:first-of-type {
            ${Text('medium1', 'alternate')};
            color: ${(props) =>
              props.theme.widget.dispatchAndDateCountdownWidget?.color ??
              props.theme.colors.palette.greys.white};
          }
        `}
`

export const TitleSpan = styled.span<{
  digitsColour?: string
}>`
  ${Text('xsmall', 'default')};

  color: ${(props) =>
    props.digitsColour ??
    props.theme.widget.dispatchAndDateCountdownWidget?.colorText ??
    props.theme.colors.palette.greys.white};
  text-transform: ${(props) =>
    props.theme.widget.dispatchAndDateCountdownWidget?.textTransform};
`
